import React from 'react';
import { IBanner } from '../../types/content';
import { IContent } from '../../types';
import Banner from './Banner';
import './Banners.scss';
import { withContent } from '../../hoc/withContext';

interface IBannerListProps {
  context?: IContent;
}

const BannerList = ({ context }: IBannerListProps) => {
  return (
    <div className="banners_component_container">
      {context.banners.map((bannerItem: IBanner, index: number) => (
        ((bannerItem.visible === "TRUE" || bannerItem.visible === undefined)&&(
          <Banner
            bannerItem={bannerItem}
            ctas={context.cta}
            key={'banner_' + index}
          />
        ))
      ))}
    </div>
  );
};

export default withContent(BannerList);
